/**
 * Angular imports.
 */
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/**
 * Service imports.
 */
import { ImageGroupService } from '../../../dataservices/master-service/image-group.service';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { NewLanguageService } from './../../../dataservices/new-language/new-language.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { AuthService } from '../../../auth/auth.service';
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';

/**
 * Constant import.
 */
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from '../../../constants/app.constants';
import { EVENT_NAME } from './../../../analytics-event/analytics.constant';

/**
 * Import interface.
 */
import { AnalyticsInterface } from '../../../analytics-event/analytics.model';
/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
/**
 * Posting Card Component
 */
@Component({
  selector: 'app-posting-card',
  templateUrl: './posting-card.component.html',
  styleUrls: ['./posting-card.component.scss']
})
export class PostingCardComponent implements OnInit {
  public posting_card_image = {
    prflclass: 'text-uppercase box-size-56 text-center rounded-circle text-white d-table-cell align-middle',
    prflpic: '',
    prflfname: '',
    prflmname: '',
    prfllname: '',
    prflrname: '',
    prflcid: '',
    prfltype: '',
    prflpicclass: 'rounded-circle box-size-56 post-pic',
    badge: { is_verified: 0, is_show: true },
    full_name: '',
    is_action: true,
    anonymous: '0',
    partial_permission_state: ''
  };
  @Input() dataObj;
  public loginUserCustomeId = '';
  public user_profile_pic_path = '';
  public tooltip_data = [];

  /**
   * Screen name for analytics event.
   */
  public screenName = SCREEN_NAME.GRAND_ROUND;


  /**
   * Receive the status of post button.
   */
  @Input() isPostButtonDisable = false;
  /**
   * Analytics data object for post bar click.
   */
  public analyticsPostBar: AnalyticsInterface;

  /**
   * Necessary instances.
   */
  constructor(
    private route: ActivatedRoute,
    public fcs: FunCollectionService,
    private authService: AuthService,
    public dss: DataStorageService,
    public igs: ImageGroupService,
    public mls: NewLanguageService,
    private analyticSdk: Analytics,
    private masterService: MasterserviceService) {
    this.loginUserCustomeId = this.authService.getbyName('profile_obj');
    this.posting_card_image.prflcid = this.loginUserCustomeId;
    this.posting_card_image.prflpic = this.dss.user_profile_data.profile.profile_pic_path;
    this.posting_card_image.prflrname = this.dss.user_profile_data.profile.registered_name;
    this.posting_card_image.prflfname = this.dss.user_profile_data.profile.first_name;
    this.posting_card_image.prfllname = this.dss.user_profile_data.profile.last_name;
    this.posting_card_image.full_name = this.dss.user_profile_data.profile.full_name;
    this.posting_card_image.badge.is_verified = (this.dss.user_profile_data.profile.permission == 'all') ? 1 : 0;
    this.user_profile_pic_path = this.dss.user_profile_data.profile.profile_pic_path;
    this.posting_card_image.partial_permission_state = this.dss.user_profile_data.profile.partial_permission_state;
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.get('post') == 'true') {
      this.fcs.openFeedPostModal();
    }

    this.tooltip_data = this.dss.tooltip_list.filter(obj => obj.screen_identifier == 'GRAND_ROUND');

    /**
     * Set analytics data for analytics event.
     */
    this.analyticsPostBar = {
      'event_name': EVENT_NAME.POST_BAR_CLICK,
      'product_type': 0,
      'product_type_id': 0,
      'screen_name': SCREEN_NAME.GRAND_ROUND,
    };
  }
  openFeedPostModal(): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, '0', this.fcs.currentScreename, CTA_TYPE.BAR, ACTION_TYPE.CLICK, ACTION_ON.CREATE_POST, null);
    this.fcs.openFeedPostModal();
  }
}
